export default __webpack_public_path__ + "static/media/spain.4e4d7e13.svg";